<div *ngIf="type === 'error'" id="error" class="relative w-full h-full sm:min-w-120 min-h-60 bg">
  <div class="absolute-center text-center border-dashed rounded-md py-9 px-12 w-full">
    <mat-icon class="icon-size-24" color="primary" svgIcon="warning"></mat-icon>
    <h3 class="font-bold text-lg" *ngIf="title !== null">
      {{ title === '' ? ('something Wrong!' | transloco) : title }}
    </h3>
    <p class="text-secondary">
      {{ bodyMessage ? bodyMessage : ('Please refresh the page or try again later.' | transloco) }}
    </p>
  </div>
</div>

<div
  *ngIf="type === 'empty'"
  class="relative w-full h-full min-h-300 min-h-60 sm:min-w-120 min-w-full"
  [class.bg]="!imageSrc"
>
  <div class="content-center text-center border-dashed rounded-md py-9 px-12 w-full">
    <img
      *ngIf="imageSrc; else emptyIcon"
      [src]="imageSrc"
      [alt]="imageAlt || ('no data!' | transloco)"
      class="mx-auto mb-4 max-h-28 max-w-48 object-contain"
    />
    <ng-template #emptyIcon>
      <mat-icon class="icon-size-24" color="primary" svgIcon="mat_solid:sticky_note_2"></mat-icon>
    </ng-template>
    <h3 class="font-bold text-lg">{{ 'no data!' | transloco }}</h3>
    <p class="text-secondary" *ngIf="!bodyMessage">
      {{ 'No data found.' | transloco }}
    </p>

    <p class="text-secondary" *ngIf="bodyMessage" [innerHTML]="bodyMessage"></p>
    <ng-content></ng-content>
  </div>
</div>
<div
  *ngIf="type === 'empty_buildings'"
  class="relative w-full h-full min-h-300 bg min-h-60 sm:min-w-120 min-w-full"
>
  <div class="content-center text-center border-dashed rounded-md py-9 px-12 w-full">
    <mat-icon class="icon-size-24" color="primary" svgIcon="mat_solid:domain"></mat-icon>
    <h3 class="font-bold text-lg">{{ 'No Buildings' | transloco }}</h3>

    <p *ngIf="bodyMessage" [innerHTML]="bodyMessage" class="text-secondary"></p>
  </div>
</div>

<div
  *ngIf="type === 'emptyCategory'"
  class="relative w-full h-full sm:min-h-300 bg min-w-120 min-h-60"
>
  <div class="absolute-center text-center border-dashed rounded-md py-9 px-12 w-full">
    <mat-icon class="icon-size-24" color="primary" svgIcon="mat_solid:sticky_note_2"></mat-icon>
    <h3 class="font-bold text-lg">{{ 'no data!' | transloco }}</h3>
    <p class="text-secondary" *ngIf="!bodyMessage">
      {{ 'Please select a category with files to list.' | transloco }}
    </p>
    <p class="text-secondary" *ngIf="bodyMessage" [innerHTML]="bodyMessage"></p>
  </div>
</div>
